import Vue from 'vue';
import Vuex from 'vuex';
import * as actions from './actions';
import * as mutations from './mutations';
import * as getters from './getters';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    isLoading: false, // 是否展示loading动画
    orderBy: 'sale', // 根据什么字段排序
    goodsInfo: { // 商品详情
      goodsImg: [],
      title: '',
      tags: [],
      discount: [],
      promotion: [],
      remarksNum: 0,
      setMeal: [],
      hot: [],
      goodsDetail: [],
      param: [],
      remarks: []
    },
    userInfo: { // 用户信息
      username: ''
    },
    token:'',
    signUpStep: 0, // 登陆步骤
    marketing: { // 营销
      CarouselItems: [], // 轮播图
      activity: [] // 活动
    },
    seckills: { // 秒杀
      deadline: {
        hours: 0,
        minute: 0,
        seconds: 0
      },
      goodsList: []
    },
    computer: {}, // 电脑专栏
    eat: {}, // 爱吃专栏
    asItems: [], // 广告
    goodsList: [], // 商品列表
    shoppingCart: [], // 购物车
    newShoppingCart: [], // 刚加入的购物车，作为展示
    recommend: [], // 推荐购买

    inPersonalCenter: false,//当前是否在个人中心模块
    inUserCenter: false,//当前是否在用户登录有关模块
    shopUser: null,//我的店铺
    headerNavIndex: null,//个人中心顶部的nav的index
    headerNavChangeType: '',//个人中心顶部的nav的index变动的类型（是不是点击跳转的，是的话为click）
    sideNavIndex: null,//个人中心侧边栏的nav的index
    categoryCode:null,//内容跳详情页是的选项卡位置
    buyer:[//分一二级数组，一级数组为左侧可点击的导航，二级数组为该导航中具体的页面route的name
      ['PersonalCenter'], // 我的订单
      ['PersonalPurchaseOrder'], // 我的求购订单
      ['PersonalPurchaseAfterSales'], // 售后管理
      ['PersonalPurchaseContract'], // 合同管理
      ['PersonalPurchaseInvoice'], // 申请开票
      ['PersonalPurchaseCollect'], // 收藏管理
      ['PersonalMyproperty'], // 我的资产
      ['PersonalCompanyInfo'], // 公司基本信息
      ['PersonalAccounts', 'PersonalPassword', 'Personalforgotpassword', 'PersonalFixpassword', 'Personalsuccess'], // 账号安全
      ['PersonalReceiveAddress'], // 收货地址
      ['PersonalMymessage'], // 我的消息
      ['PersonalLeaveAmessage'], // 我的留言
      ['PersonalRealNameAuthentication'], // 实名认证
      ['PersonalCompanyAuth'], // 公司认证
      ['PersonalCenterBuyerSupply'],
      ['PersonalCenterPurchaseMessage'],
      ['PersonalCenterBrokerInfo'],
      ['PersonalReceiveAddress'],
    ],
    seller:[
      // ['PersonalSaleOrder','PersonalSellerOrderDetail'],
      ['PersonalCommodityManagement', 'PersonalAddProduct', 'PersonalProductDetail'],
      ['PersonalCreditOrderManagementList', 'PersonalCreditOrderManagementDetail'],//赊销订单管理
      ['PersonalStoreInfo'],
      ['PersonalAfterSalesManagement'],//售后管理
      ['PersonalInvoiceManagement'],//发票管理
      ['PersonalContractManagementBackList'],//赊销合同列表管理
      // ['PersonalContractManagement'],//合同管理
      ['PersonalEvaluationList'],//评价列表
      // ['PersonalMerchantManagement'],//商家设置
      // ['PersonalLogisticsSetup'],
      // ['PersonalWarehouseManagement'],//仓库管理
      // ['PersonalLogisticsManagement'],//配送调拨
      ['PersonalBusinessStatistics'],//统计
      ['PersonalCreditSalesApplicationList', 'PersonalCreditSalesApplicationDetail'],//赊销额度申请
      ['PersonalCreditLimitInquiryList', 'PersonalcreditLimitInquiryAllList'],//赊销额度查询
      ['PersonalIncreaseInCreditSalesLimitList', 'PersonalIncreaseInCreditSalesLimitDetail'],//赊销额度提升
    ]
  },
  getters,
  actions,
  mutations
});



// WEBPACK FOOTER //
// ./src/vuex/store.js